<template>
  <v-container fluid class="mx-0 px-0">
    <v-data-table
      :headers="filteredHeaders"
      :items="itemsList"
      :loading="loading"
      :search="search"
      :item-class="rowClass"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: 'Rodyti po:',
        itemsPerPageAllText: 'visi',
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :hide-default-footer="hideFooter"
      :items-per-page="pageSize"
    >
      <template #top>
        <v-toolbar flat v-if="toolbar">
          <v-text-field
            v-model="search"
            prepend-icon="mdi-magnify"
            label=""
            single-line
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>
          <el-button-prideti
            :disabled="isReadonly"
            primary
            @click.native.stop="openObjektas()"
          >
            Pridėti IDK
          </el-button-prideti>
        </v-toolbar>
      </template>
      <template #[`item.actions`]="{ item }">
        <el-table-action :item="item" @deleteItem="deleteItem(item)" />
      </template>
      <template slot="loading">
        Kraunasi...
      </template>
      <template slot="no-results">
        Duomenų nėra
      </template>
      <template slot="no-data">
        Duomenų nėra
      </template>
      <template #[`footer.page-text`]="props">
        Rodoma {{ props.pageStart }}-{{ props.pageStop }} iš
        {{ props.itemsLength }}
      </template>
    </v-data-table>
    <modal-perleidimas-objektas
      :key="modalObjektasKey"
      v-model="showObjektas"
      @savedData="savedObjektas"
    />
    <modal-delete
      title="Šalinti dokumentą?"
      :text="
        `Ar norite pašalinti dokumentą <strong>${modalDeleteVardas}</strong>?`
      "
      v-model="showDelete"
      :item="modalDeleteItem"
      @confirmDelete="confirmDelete"
    />
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import HipotekaMap from '../hipoteka/hipotekaMap'
import ModalPerleidimasObjektas from '../modals/ModalPerleidimasObjektas'
import ModalDelete from '../modals/ModalDelete'
import rowClass from '../../mixins/rowClass'
import busena from '../../mixins/busena'
import userRole from '../../mixins/userRole'

export default {
  name: 'PerleidimasObjektai',
  components: {
    ModalPerleidimasObjektas,
    ModalDelete,
  },
  props: {
    perleidziaIds: Array,
    objektai: Array,
    toolbar: { type: Boolean, default: true },
    readonly: { type: Boolean, default: false },
  },
  mixins: [busena, rowClass, userRole],
  data() {
    return {
      pageloading: true,
      loading: true,
      search: null,
      showObjektas: false,
      modalObjektasKey: null,
      modalObjektasRefresh: 0,
      salys: [],
      showDelete: false,
      modalDeleteVardas: '',
      modalDeleteItem: null,
      modalDeleteRole: null,
      itemsPerPageOptions: [10, 50, -1],
      pageSize: 10,
    }
  },
  computed: {
    ...mapGetters(['appSavitarna']),
    headers() {
      return [
        {
          text: 'Identifikavimo kodas (IDK)',
          align: 'start',
          value: 'obj_identifikavimo_kodas',
        },
        {
          text: 'Pranešimo rūšis',
          align: 'start',
          value: 'hipotekaTipas',
        },
        {
          text: 'Įregistravimo data',
          align: 'start',
          value: 'obj_iregistravimo_data',
        },
        {
          text: 'Pastaba',
          align: 'start',
          value: 'klaida',
        },
        {
          text: 'Veiksmai',
          align: 'center',
          sortable: false,
          value: 'actions',
          width: 100,
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter(item => {
        return !item.hide
      })
    },

    itemsList() {
      return this.objektai
        .map(item => {
          item.hipotekaTipas = HipotekaMap['hipotekaTipas'][item.obj_tipas]
            ? HipotekaMap['hipotekaTipas'][item.obj_tipas].title
            : item.obj_tipas

          item.canEdit = this.isPriimaRole
          item.canDelete = !this.isReadonly

          return item
        })
        .sort((a, b) => {
          if (!a.klaida && b.klaida) return 1
          return 0
        })
    },
    hideFooter() {
      return this.itemsList.length <= 10
    },
    isSavitarna() {
      return this.appSavitarna
    },
    isReadonly() {
      return this.readonly
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.pageloading = false
      this.loading = false
    },
    openObjektas() {
      if (this.perleidziaIds.length == 0) {
        window._VMA.$emit(
          'DATA_ERROR',
          'Neįvestas nei vienas reikalavimo teisę perleidžiantis kreditorius'
        )
        return
      }
      this.modalObjektasKey = 'objektas' + this.modalObjektasRefresh++
      this.showObjektas = true
    },
    savedObjektas(idkList) {
      this.tikrintiObjektas(idkList)
    },
    tikrintiObjektas(tikrintiIdk) {
      this.loading = true
      const data = {
        perleidziantys: this.perleidziaIds,
        idk: tikrintiIdk,
      }

      this.$axios
        .post(`perleidimas/idk`, data)
        .then(res => {
          this.$emit('savedObjektas', res.data.idk)
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.showObjektas = false
        })
    },
    deleteItem(item) {
      this.modalDeleteVardas = item.obj_identifikavimo_kodas
      this.modalDeleteItem = Object.assign({}, item)
      this.showDelete = true
    },
    confirmDelete(item) {
      this.$emit('deletedObjektas', item)
      this.showObjektas = false
    },
    rowClass(item) {
      if (item.klaida) {
        return `perleidimas-klaida`
      }
      return ''
    },
  },
}
</script>
